import { ReactNode } from "react";

interface DataCellProps {
  children: ReactNode;
  className?: string;
  muted?: boolean;
}

export function DataCell({ children, className = "", muted = false }: DataCellProps) {
  return (
    <span className={`${muted ? "text-muted-foreground" : ""} ${className}`}>
      {children}
    </span>
  );
}
